import { validEmail, validPassword } from './utilFunctions';

export default () => ({
	error: null,
	requestInProgress: false,
	submit(e) {
		e.preventDefault();

		const [email, password] = [...this.$el.querySelectorAll('input')].map(
			(input) => input.value
		);

		if (
			!email ||
			!password ||
			this.requestInProgress ||
			!validEmail(email).valid ||
			!validPassword(password).valid
		) {
			return;
		}

		this.requestInProgress = true;
		this.error = null;
		let formData = new FormData();
		formData.append('email', email);
		formData.append('password', password);
		fetch('/api/login', {
			method: 'POST',
			headers: {
				accept: 'aplication/json',
			},
			body: formData,
		})
			.then((resp) => resp.json())
			.then((data) => {
				if ('exception' in data && data.message === 'auth:failed') {
					this.error =
						'Hibás email cím vagy jelszó! Kérjük próbálja újra.';
					return;
				}

				if (
					'exception' in data &&
					data.message === 'user:notAccepted'
				) {
					this.error =
						'A felhasználó még nincsen aktiválva. Kérjük próbálja újra később.';
					return;
				}

				if ('data' in data && 'user' in data.data) {
					this.$store.account.login(data.data.user);
					this.$dispatch('modalcloseid', { modalid: 'loginmodal' });
					window.location.reload();
					return;
				}

				if ('message' in data) {
					this.error = data.message;
					return;
				}

				throw new Error('Invalid data response.');
			})
			.catch((err) => {
				console.error(err);
				this.error = 'Ismeretlen hiba történt a bejelentkezés közben.';
			})
			.finally(() => {
				this.requestInProgress = false;
			});
	},
});
